import React from 'react'

const WIP = props => {
  return (
    <div className="work-in-progress">
      <span data-position="top">
        This screen is a <br /> work in progress
      </span>
    </div>
  )
}

export default WIP
